import { render, staticRenderFns } from "./ToPresidentDashboard.vue?vue&type=template&id=72e9ae06&scoped=true&"
import script from "./ToPresidentDashboard.vue?vue&type=script&lang=js&"
export * from "./ToPresidentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ToPresidentDashboard.vue?vue&type=style&index=0&id=72e9ae06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e9ae06",
  null
  
)

export default component.exports